// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"2668bb0c","545":"3d8130cd"}[chunkId] + ".chunk.css";
};